import React, { useState } from 'react';
import { 
    Table, Tag, Space, Button, Card, Row, Col, Form, Input, 
    Select, DatePicker, Typography, Dropdown, Drawer,
    Upload, Cascader, Tooltip, InputNumber, Alert, Divider, Radio, message
} from 'antd';
import { 
    SearchOutlined, ReloadOutlined, PlusOutlined, CopyOutlined, 
    DownOutlined, DeleteOutlined, InboxOutlined, InfoCircleOutlined,
    WalletOutlined, CreditCardOutlined, SafetyOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './ProductDevelop.css';
const { Title, Text } = Typography;

const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

// ... categoryCascaderOptions 保持不变 ...

const categoryCascaderOptions = [
    {
        label: '摄像机',
        value: '1',
        children: [
            {
                label: '室内摄像机',
                value: '1-1',
                children: [
                    { label: '卡片机 (Wi-Fi)', value: '111' },
                    { label: '云台摄像机 (Wi-Fi)', value: '112' },
                    { label: '电池摄像机 (Wi-Fi)', value: '113' },
                ]
            },
            {
                label: '户外摄像机',
                value: '1-2',
                children: [
                    { label: '长电枪机 (Wi-Fi)', value: '121' },
                    { label: '长电球机 (Wi-Fi)', value: '122' },
                    { label: '电池枪机 (Wi-Fi)', value: '123' },
                    { label: '电池球机 (Wi-Fi)', value: '124' },
                    { label: '电池AOV摄像机 (Wi-Fi)', value: '125' },
                ]
            },
            {
                label: '4G智能摄像机',
                value: '1-3',
                children: [
                    { label: '长电枪机 (4G)', value: '131' },
                    { label: '长电球机 (4G)', value: '132' },
                    { label: '电池枪机 (4G)', value: '133' },
                    { label: '电池球机 (4G)', value: '134' },
                ]
            },
            {
                label: '融合摄像机',
                value: '1-4',
                children: [
                    { label: '移动摄像机', value: '141' },
                    { label: '智能喂鸟摄像机', value: '142' },
                    { label: '宝宝监护摄像机', value: '143' },
                    { label: '宠物门禁', value: '144' },
                    { label: '宠物TV', value: '145' },
                    { label: '打猎相机 (4G)', value: '146' },
                ]
            }
        ]
    },
    {
        label: '网关类',
        value: '2',
        children: [
            { label: 'HUB', value: '21' },
        ]
    },
    {
        label: '存储类',
        value: '3',
        children: [
            { label: 'NVR', value: '31' },
        ]
    }
];

// TODO: 联调时替换为真实接口
const ProductDevelop = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [createForm] = Form.useForm();
    const [purchaseForm] = Form.useForm();
    const developMode = Form.useWatch('developMode', createForm) || 'self';
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [purchaseDrawerVisible, setPurchaseDrawerVisible] = useState(false);
    const [editingProduct, setEditingProduct] = useState(null);
    const [, setCurrentPurchaseProduct] = useState(null);
    
    // 模拟账户余额数据
    const [accountInfo] = useState({
        balance: -2500.50,
        creditLimit: 5000.00
    });

    const showPurchaseDrawer = (record) => {
        setCurrentPurchaseProduct(record);
        purchaseForm.setFieldsValue({
            productName: record.productName,
            productId: record.productId,
            price: record.price,
            quantity: 100
        });
        setPurchaseDrawerVisible(true);
    };

    const handlePurchaseSubmit = async () => {
        try {
            const values = await purchaseForm.validateFields();
            const totalPrice = values.price * values.quantity;
            const availableTotal = accountInfo.balance + accountInfo.creditLimit;
            
            if (totalPrice > availableTotal) {
                message.error('可消费金额不足，请充值后再试');
                return;
            }

            message.success(`成功购买 ${values.quantity} 个授权，共计 ¥${totalPrice.toFixed(2)}`);
            setPurchaseDrawerVisible(false);
            purchaseForm.resetFields();
        } catch (error) {
            console.log('Purchase validate failed:', error);
        }
    };

    // 状态工具函数：将中文状态转换为数字 code 或 保留原样
    const getStatusState = (statusText) => {
        if (statusText === '开发中') return '0';
        if (statusText === '已发布') return '1';
        if (statusText === '隐藏') return '2';
        return statusText; // 如果是“发布中”等其他文本，直接传过去
    };

    const showDrawer = (record = null) => {
        if (record && record.key) {
            // 编辑模式
            setEditingProduct(record);
            // 这里为了演示回显，根据 mock 里的 category 等字段进行转换
            // 实际开发中应该根据 record 的真实数据结构
            let categoryValue = 'camera_fix'; // 默认值
            if (record.category.includes('PTZ')) categoryValue = 'camera_ptz';
            if (record.category.includes('HUB')) categoryValue = 'gateway_hub';
            if (record.category.includes('NVR')) categoryValue = 'storage_nvr';

            createForm.setFieldsValue({
                name: record.productName,
                category: categoryValue,
                netMode: ['WIFI'], // mock 数据里没这些，先给个默认回显
                powerMode: 'normal',
                model: 'HM-MODEL-001'
            });
        } else {
            // 新增模式
            setEditingProduct(null);
            createForm.resetFields();
        }
        setDrawerVisible(true);
    };

    const handleSaveAndDevelop = () => {
        setDrawerVisible(false);
        navigate('/product/develop');
    };

    const onClose = () => {
        setDrawerVisible(false);
        createForm.resetFields();
    };

    const moreActionsMenu = (record) => ({
        items: [
            {
                key: 'copy',
                label: '复制产品',
                icon: <CopyOutlined />
            },
            {
                key: 'delete',
                label: '删除产品',
                danger: true,
                icon: <DeleteOutlined />,
                disabled: record.source === 'self' && record.isEcoUsed,
                title: record.isEcoUsed ? '该产品已被其他企业选用为方案产品，不可删除' : undefined,
            }
        ]
    });

    const mockData = [
        {
            key: '1',
            index: 1,
            productName: '0129产品创建',
            productId: 'P2MYHLjna9',
            category: '摄像机',
            status: '已发布',
            isEcoUsed: true,
            price: '1.00',
            testQuota: 10,
            productionQuota: 5,
            freeQuota: 5,
            producedNum: 47,            operator: 'heying2025',
            createTime: '2026-01-29',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        {
            key: '2',
            index: 2,
            productName: '01281615产品创建',
            productId: 'Pm38jEddh2',
            category: '摄像机',
            status: '开发中',
            price: '0.00',
            freeQuota: 0,
            producedNum: 0,
            operator: 'admin',
            createTime: '2026-01-28',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        {
            key: '3',
            index: 3,
            productName: '0128产品创建',
            productId: 'PHWEu9JFZd',
            category: '网关类',
            status: '发布中',
            price: '1.00',
            freeQuota: 5,
            producedNum: 0,
            operator: 'admin',
            createTime: '2026-01-28',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        {
            key: '4',
            index: 4,
            productName: '0127产品创建',
            productId: 'PJbcAJJb43',
            category: '存储类',
            status: '发布失败',
            price: '0.00',
            freeQuota: 0,
            producedNum: 0,
            operator: 'admin',
            createTime: '2026-01-27',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        {
            key: '5',
            index: 5,
            productName: '4G类目下低功耗产品',
            productId: 'Pg7yYSNj3n',
            category: '摄像机',
            status: '开发中',
            price: '2.00',
            freeQuota: 5,
            producedNum: 0,
            operator: 'heying2025',
            createTime: '2026-01-26',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        // ── 引用产品（通过设备调拨引入）──
        {
            key: '14',
            index: 14,
            productName: '工业网关 G100',
            productId: 'PRD_GW001',
            category: '网关类',
            status: '已发布',
            price: '0.00',
            freeQuota: 0,
            producedNum: 0,
            operator: '—',
            createTime: '2026-05-05',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001',
            source: 'transferred',
            vendorName: '蓝海工业自动化',
            vendorProductName: '工业网关 G100'
        },
        {
            key: '15',
            index: 15,
            productName: '4G摄像机',
            productId: 'PRD_4G001',
            category: '摄像机',
            status: '已发布',
            price: '0.00',
            freeQuota: 0,
            producedNum: 0,
            operator: '—',
            createTime: '2026-05-09',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001',
            source: 'transferred',
            vendorName: '深圳汇云科技',
            vendorProductName: '4G摄像机'
        },
        {
            key: '6',
            index: 6,
            productName: '0314',
            productId: 'PaeB9UMHqU',
            category: '摄像机',
            status: '已发布',
            price: '0.00',
            freeQuota: 0,
            producedNum: 0,
            operator: 'heying2025',
            createTime: '2026-01-25',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001',
            source: 'ecosystem',
            vendorName: '杭州云联物联网有限公司',
            vendorId: 'ENT_V02',
            vendorProductName: '4G低功耗电池摄像机方案',
            vendorProductId: 'P_ECO_002'
        },
        {
            key: '7',
            index: 7,
            productName: '4g摄像机0109',
            productId: 'P58bB7m3xG',
            category: '摄像机',
            status: '已发布',
            price: '1.00',
            freeQuota: 5,
            producedNum: 0,
            operator: 'heying2025',
            createTime: '2026-01-24',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001',
            source: 'ecosystem',
            vendorName: '东莞康林物联网有限公司',
            vendorId: 'ENT_V03',
            vendorProductName: 'NVR网络录像机方案',
            vendorProductId: 'P_ECO_004'
        },
        {
            key: '8',
            index: 8,
            productName: '复制_真实设备调试产品2',
            productId: 'PAtst9esf5',
            category: '存储类',
            status: '已发布',
            price: '5.00',
            freeQuota: 5,
            producedNum: 1,
            operator: 'heying2025',
            createTime: '2026-01-23',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        {
            key: '9',
            index: 9,
            productName: '20254设备',
            productId: 'PX7CdbXzBJ',
            category: '网关类',
            status: '开发中',
            price: '0.00',
            freeQuota: 0,
            producedNum: 0,
            operator: '',
            createTime: '2025-12-29',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        {
            key: '10',
            index: 10,
            productName: '2501',
            productId: 'PP2zkp5WHi',
            category: '摄像机',
            status: '已发布',
            price: '0.00',
            freeQuota: 0,
            producedNum: 0,
            operator: '',
            createTime: '2025-11-20',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        {
            key: '11',
            index: 11,
            productName: '测试产品11',
            productId: 'T11abc123',
            category: '摄像机',
            status: '已发布',
            price: '1.00',
            freeQuota: 0,
            producedNum: 0,
            operator: 'admin',
            createTime: '2026-02-01',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001'
        },
        {
            key: '12',
            index: 12,
            productName: '智能云台摄像机-高配版',
            productId: 'P_DRV_001',
            category: '摄像机',
            status: '已发布',
            price: '1.00',
            freeQuota: 0,
            producedNum: 200,
            operator: 'admin',
            createTime: '2026-04-21',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001',
            source: 'ecosystem',
            vendorName: '深圳芯视界科技有限公司',
            vendorId: 'ENT_V01',
            vendorProductName: '智能云台摄像机方案',
            vendorProductId: 'P_ECO_001'
        },
        {
            key: '13',
            index: 13,
            productName: '智能云台摄像机-低配版',
            productId: 'P_DRV_002',
            category: '摄像机',
            status: '已发布',
            price: '1.00',
            freeQuota: 0,
            producedNum: 0,
            operator: 'admin',
            createTime: '2026-04-22',
            enterpriseName: '瀚晖通讯',
            enterpriseId: 'ENT_001',
            source: 'ecosystem',
            vendorName: '深圳芯视界科技有限公司',
            vendorId: 'ENT_V01',
            vendorProductName: '智能云台摄像机方案',
            vendorProductId: 'P_ECO_001'
        }
    ];

    const columns = [
        { title: '序号', dataIndex: 'index', key: 'index', width: 60, align: 'center' },
        { 
            title: '产品信息', 
            key: 'productInfo', 
            width: 200,
            render: (_, record) => (
                <div>
                    <div 
                        style={{ color: '#1890ff', cursor: 'pointer' }}
                        onClick={() => navigate('/product/info', {
                            state: {
                                name: record.productName,
                                id: record.productId,
                                category: record.category,
                                status: getStatusState(record.status),
                                price: record.price,
                                freeQuota: record.freeQuota,
                                producedNum: record.producedNum,
                                createTime: record.createTime,
                                source: record.source,
                                vendorName: record.vendorName,
                                vendorProductName: record.vendorProductName,
                                stats: {
                                    stdAbility: 4,
                                    cueAbility: 2,
                                    algorithms: 3,
                                    vas: 1
                                }
                            }
                        })}
                    >
                        {record.productName}
                    </div>
                    <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{record.productId}</div>
                </div>
            )
        },
        { title: '产品类目', dataIndex: 'category', key: 'category', width: 150 },
        {
            title: '产品类型', key: 'productType', width: 100,
            render: () => <Tag color="blue" style={{ border: 'none' }}>整机产品</Tag>,
        },
        {
            title: '开发方式',
            key: 'source',
            width: 220,
            render: (_, record) => {
                if (record.source === 'ecosystem') {
                    return (
                        <div>
                            <Tag color="blue">方案派生</Tag>
                            <div style={{ fontSize: 12, fontWeight: 500 }}>{record.vendorProductName || '—'}</div>
                            <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{record.vendorProductId || '—'}</Text>
                        </div>
                    );
                }
                if (record.source === 'transferred') {
                    return <Tooltip title={`来源企业：${record.vendorName}`}><Tag color="orange">引用产品</Tag></Tooltip>;
                }
                return <Tag color="green">自研开发</Tag>;
            }
        },
        { 
            title: '产品状态', 
            dataIndex: 'status', 
            key: 'status', 
            width: 100,
            render: (status) => {
                let color = 'default';
                switch(status) {
                    case '已发布': color = 'green'; break;
                    case '开发中': color = 'orange'; break;
                    case '发布中': color = 'blue'; break;
                    case '发布失败': 
                        return (
                            <Tooltip title="平台驳回原因：产品描述不清晰，请重新检查功能定义及安装指引文案。">
                                <Tag color="red" style={{ cursor: 'pointer' }}>
                                    {status} <InfoCircleOutlined style={{ fontSize: '12px' }} />
                                </Tag>
                            </Tooltip>
                        );
                    default: color = 'default'; break;
                }
                return <Tag color={color}>{status}</Tag>
            }
        },
        { title: '授权单价 (元/个)', dataIndex: 'price', key: 'price', width: 140 },
        { 
            title: '赠送授权', 
            dataIndex: 'freeQuota', 
            key: 'freeQuota', 
            width: 110,
            render: (_, record) => (
                <div style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                    <div>测试授权：{record.testQuota || 0}个</div>
                    <div>生产授权：{record.productionQuota || record.freeQuota || 0}个</div>
                </div>
            )
        },
        { title: '采购生产授权', dataIndex: 'producedNum', key: 'producedNum', width: 120 },
        { title: '操作人', dataIndex: 'operator', key: 'operator', width: 120 },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 120 },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: 400,
            render: (_, record) => {
                const moreAction = (
                    <Dropdown menu={moreActionsMenu(record)} trigger={['click']}>
                        <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={(e) => e.preventDefault()}>
                            更多操作 <DownOutlined style={{ fontSize: '10px' }} />
                        </Button>
                    </Dropdown>
                );

                // 引用产品（调拨引入）——只读，操作列为空
                if (record.source === 'transferred') {
                    return (
                        <Text type="secondary" style={{ fontSize: 12 }}>—</Text>
                    );
                }

                switch(record.status) {
                    case '开发中':
                    case '发布失败':
                        return (
                            <Space size="middle">
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => navigate('/product/develop')}>继续开发</Button>
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => navigate(`/firmware/version?productId=${record.productId}&productName=${encodeURIComponent(record.productName)}`)}>添加固件</Button>
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap', color: '#52c41a' }} onClick={() => navigate('/product/develop')}>发布产品</Button>
                                {moreAction}
                            </Space>
                        );
                    case '发布中':
                        return (
                            <Space size="middle">
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }}>复制产品</Button>
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => navigate(`/firmware/version?productId=${record.productId}&productName=${encodeURIComponent(record.productName)}`)}>添加固件</Button>
                            </Space>
                        );
                    case '已发布':
                        if (record.source === 'ecosystem') {
                            return (
                                <Space size="middle">
                                    <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => showPurchaseDrawer(record)}>购买授权</Button>
                                    <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => navigate(`/firmware/version?productId=${record.productId}&productName=${encodeURIComponent(record.productName)}&source=ecosystem`)}>查看固件</Button>
                                    <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => navigate('/product/app')}>App配置</Button>
                                    {moreAction}
                                </Space>
                            );
                        }
                        return (
                            <Space size="middle">
                                <Button 
                                    type="link" 
                                    style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }}
                                    onClick={() => showPurchaseDrawer(record)}
                                >
                                    购买授权
                                </Button>
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => { navigate(`/firmware/version?productId=${record.productId}&productName=${encodeURIComponent(record.productName)}`); }}>添加固件</Button>
                                <Button 
                                    type="link"
                                    style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }}
                                    onClick={() => navigate('/product/app')}
                                >
                                    App配置
                                </Button>
                                {moreAction}
                            </Space>
                        );
                    default:
                        return (
                            <Space size="middle">
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }}>复制产品</Button>
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => navigate(`/firmware/version?productId=${record.productId}&productName=${encodeURIComponent(record.productName)}`)}>添加固件</Button>
                                <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={() => navigate('/product/develop')}>继续开发</Button>
                            </Space>
                        );
                }
            }
        }
    ];

    const onReset = () => {
        form.resetFields();
    };

    return (
        <div className="product-develop-container">
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>整机开发</Title>
      </div>
            <Alert
                type="info"
                showIcon
                closable
                style={{ marginBottom: 16, borderRadius: 8 }}
                message={
                    <div style={{ fontSize: 13 }}>
                        <div style={{ marginBottom: 4 }}>整机产品可关联所属方案（PCBA）；有方案的整机只读使用方案固件，OTA 仅针对整机产品。</div>
                        <div style={{ marginBottom: 4 }}><Tag color="orange" style={{ marginRight: 4 }}>引用产品</Tag>来源其他合作企业的设备调拨，仅可查看关联产品的物模型配置（只读）。</div>
                        <div style={{ marginBottom: 4 }}><Tag color="blue" style={{ marginRight: 4 }}>方案派生</Tag>你的产品基于合作方案产品开发，你可修改产品物模型，并获取方案产品固件，对设备进行 OTA 升级。</div>
                    </div>
                }
            />
            {/* <Card className="main-tabs" bodyStyle={{ padding: '0 24px' }} bordered={false}>
                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane tab="产品列表" key="1" />
                    <Tabs.TabPane tab="授权产品" key="2" />
                </Tabs>
            </Card> */}

            <Card bordered={false} style={{ marginBottom: 16, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Form form={form} layout="inline" style={{ flexWrap: 'wrap', gap: '8px 0' }}>
                    <Form.Item style={{ marginRight: 8 }}>
                        <Input.Group compact style={{ display: 'flex' }}>
                            <Form.Item name="productNameKey" noStyle initialValue="productName">
                                <Select style={{ width: 100 }} onChange={() => form.setFieldsValue({ productNameValue: undefined })}>
                                    <Option value="productName">产品名称</Option>
                                    <Option value="productId">产品ID</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item shouldUpdate={(p, c) => p.productNameKey !== c.productNameKey} noStyle>
                                {({ getFieldValue }) => {
                                    const key = getFieldValue('productNameKey') || 'productName';
                                    return key === 'productName' ? (
                                        <Form.Item name="productNameValue" noStyle>
                                            <Select showSearch placeholder="请选择产品" style={{ width: 180 }} allowClear optionFilterProp="label"
                                                options={Array.from(new Set(mockData.map(i => i.productName))).map(v => ({ label: v, value: v }))} />
                                        </Form.Item>
                                    ) : (
                                        <Form.Item name="productNameValue" noStyle><Input style={{ width: 180 }} placeholder="请输入产品ID" allowClear /></Form.Item>
                                    );
                                }}
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>
                    <Form.Item name="status" style={{ marginRight: 8 }}>
                        <Select placeholder="产品状态" style={{ width: 110 }} allowClear>
                            <Option value="developing">开发中</Option>
                            <Option value="releasing">发布中</Option>
                            <Option value="published">已发布</Option>
                            <Option value="failed">发布失败</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="source" style={{ marginRight: 8 }}>
                        <Cascader placeholder="开发方式" style={{ width: 180 }} allowClear changeOnSelect options={[
                            { value: 'self', label: '自研' },
                            { value: 'ecosystem', label: '方案派生', children: [
                                { value: 'P_ECO_001', label: '智能云台摄像机方案' },
                                { value: 'P_ECO_002', label: '4G低功耗电池摄像机方案' },
                                { value: 'P_ECO_003', label: '智能门铃方案' },
                                { value: 'P_ECO_004', label: 'NVR网络录像机方案' },
                            ]},
                            { value: 'transferred', label: '引用产品', children: [
                                { value: 'ENT_8802', label: '蓝海工业自动化' },
                                { value: 'HM_8827_X', label: '深圳汇云科技' },
                            ]},
                        ]} />
                    </Form.Item>
                    <Form.Item name="category" style={{ marginRight: 8 }}>
                        <Cascader options={categoryCascaderOptions} placeholder="产品类目" changeOnSelect allowClear style={{ width: 140 }} />
                    </Form.Item>
                    <Form.Item style={{ marginRight: 8 }}>
                        <Input.Group compact style={{ display: 'flex' }}>
                            <Form.Item name="enterpriseKey" noStyle initialValue="enterpriseName">
                                <Select style={{ width: 100 }} onChange={() => form.setFieldsValue({ enterpriseValue: undefined })}>
                                    <Option value="enterpriseName">所属企业</Option>
                                    <Option value="enterpriseId">企业ID</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item shouldUpdate={(p, c) => p.enterpriseKey !== c.enterpriseKey} noStyle>
                                {({ getFieldValue }) => {
                                    const key = getFieldValue('enterpriseKey') || 'enterpriseName';
                                    return key === 'enterpriseName' ? (
                                        <Form.Item name="enterpriseValue" noStyle>
                                            <Select showSearch placeholder="请选择企业" style={{ width: 180 }} allowClear optionFilterProp="label"
                                                options={Array.from(new Set(mockData.map(i => i.enterpriseName))).map(v => ({ label: v, value: v }))} />
                                        </Form.Item>
                                    ) : (
                                        <Form.Item name="enterpriseValue" noStyle><Input style={{ width: 180 }} placeholder="请输入企业ID" allowClear /></Form.Item>
                                    );
                                }}
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>
                    <Form.Item name="createTime" style={{ marginRight: 8 }}>
                        <RangePicker placeholder={['开始时间', '结束时间']} />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                            <Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>

            <Card bordered={false}>
                <div style={{ marginBottom: 16 }}>
                    <Button type="primary" icon={<PlusOutlined />} onClick={showDrawer}>创建整机</Button>
                </div>
                <Table 
                    columns={columns} 
                    dataSource={mockData} 
                    scroll={{ x: 1500 }}
                    pagination={{
                        showTotal: (total) => `共 ${total} 条记录`,
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        locale: {
                            items_per_page: '条/页',
                            jump_to: '跳至',
                            jump_to_confirm: '确定',
                            page: '页',
                            prev_page: '上一页',
                            next_page: '下一页',
                            prev_5: '向前 5 页',
                            next_5: '向后 5 页',
                            prev_3: '向前 3 页',
                            next_3: '向后 3 页',
                        }
                    }}
                />
            </Card>

            <Drawer
                title={editingProduct ? "编辑整机" : "创建整机"}
                width={560}
                onClose={onClose}
                open={drawerVisible}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Space>
                            <Button onClick={onClose}>取消</Button>
                            <Button type="primary" onClick={handleSaveAndDevelop}>保存并开发</Button>
                        </Space>
                    </div>
                }
            >
                <Form
                    form={createForm}
                    layout="horizontal"
                    labelCol={{ span: 5 }}
                    wrapperCol={{ span: 18 }}
                    labelAlign="right"
                >
                    <Form.Item
                        name="category"
                        label="产品类目"
                        rules={[{ required: true, message: '请选择产品类目' }]}
                    >
                        <Cascader 
                            options={categoryCascaderOptions} 
                            placeholder="请选择三级产品类目"
                            expandTrigger="hover"
                        />
                    </Form.Item>

                    {/* <Form.Item
                        name="netMode"
                        label="联网方式"
                        rules={[{ required: true, message: '请选择联网方式' }]}
                    >
                        <Select mode="multiple" placeholder="请选择联网方式">
                            <Option value="WIFI">WIFI</Option>
                            <Option value="4G">移动网络</Option>
                            <Option value="wired">有线网络</Option>
                        </Select>
                    </Form.Item> */}

                    <Form.Item
                        name="name"
                        label="产品名称"
                        rules={[{ required: true, message: '请输入产品名称' }]}
                    >
                        <Input placeholder="请输入产品名称" maxLength={40} showCount />
                    </Form.Item>

                    <Form.Item name="developMode" label="开发方式" initialValue="self">
                        <Radio.Group onChange={() => createForm.setFieldsValue({ parentPlan: undefined })}>
                            <Radio value="self">自研开发</Radio>
                            <Radio value="plan">基于方案</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {developMode === 'plan' && (
                        <Form.Item name="parentPlan" label="方案产品" rules={[{ required: true, message: '请选择方案产品' }]}>
                            <Select
                                placeholder="请选择本企业创建的方案产品"
                                showSearch
                                optionFilterProp="label"
                                options={[
                                    { value: 'P_ECO_001', label: '智能云台摄像机方案（P_ECO_001）' },
                                    { value: 'P_ECO_002', label: '4G低功耗电池摄像机方案（P_ECO_002）' },
                                    { value: 'P_ECO_003', label: '智能门铃方案（P_ECO_003）' },
                                    { value: 'P_ECO_004', label: 'NVR网络录像机方案（P_ECO_004）' },
                                ]}
                            />
                        </Form.Item>
                    )}

                    <Form.Item
                        name="model"
                        label="产品型号"
                    >
                        <Input placeholder="请输入产品型号" maxLength={40} showCount />
                    </Form.Item>

                    <Form.Item
                        name="image"
                        label={
                            <span>
                                产品图 <InfoCircleOutlined style={{ color: '#8c8c8c' }} />
                            </span>
                        }
                    >
                        <Upload.Dragger name="files" action="/upload.do" maxCount={1}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">拖拽图片到这或者点击上传</p>
                            <p className="ant-upload-hint">最多可上传1个文件</p>
                            <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: 8 }}>
                                请上传png、jpg、jpeg格式的文件,文件大小不超过20MB
                            </div>
                        </Upload.Dragger>
                    </Form.Item>

                    <Form.Item
                        name="description"
                        label="产品描述"
                    >
                        <TextArea rows={4} placeholder="请输入产品描述" maxLength={200} showCount />
                    </Form.Item>
                </Form>
            </Drawer>

            <Drawer
                title="购买产品授权"
                width={640}
                onClose={() => setPurchaseDrawerVisible(false)}
                open={purchaseDrawerVisible}
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Space>
                            <Button onClick={() => setPurchaseDrawerVisible(false)}>取消</Button>
                            <Button type="primary" onClick={handlePurchaseSubmit}>确认购买</Button>
                        </Space>
                    </div>
                }
            >
                <Alert
                    message="账户信息"
                    description={
                        <div style={{ fontSize: '13px' }}>
                            <Row gutter={[16, 8]}>
                                <Col span={12}>
                                    <Space><WalletOutlined /> <Text type="secondary">账户余额:</Text> <Text strong>¥ {accountInfo.balance.toLocaleString()}</Text></Space>
                                </Col>
                                <Col span={12}>
                                    <Space><CreditCardOutlined /> <Text type="secondary">信用额度:</Text> <Text strong>¥ {accountInfo.creditLimit.toLocaleString()}</Text></Space>
                                </Col>
                                <Col span={24}>
                                    <Divider style={{ margin: '8px 0' }} />
                                    <Space><SafetyOutlined /> <Text type="secondary">可消费金额:</Text> <Text strong style={{ fontSize: '16px', color: '#52c41a' }}>¥ {(accountInfo.balance + accountInfo.creditLimit).toLocaleString()}</Text></Space>
                                </Col>
                            </Row>
                        </div>
                    }
                    type="info"
                    showIcon
                    style={{ marginBottom: 24, borderRadius: 8 }}
                />

                <Form
                    form={purchaseForm}
                    layout="vertical"
                >
                    <Row gutter={16}>
                        <Col span={12}><Form.Item name="productName" label="产品名称"><Input disabled /></Form.Item></Col>
                        <Col span={12}><Form.Item name="productId" label="产品ID"><Input disabled /></Form.Item></Col>
                    </Row>
                    
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="price" label="授权单价 (元/个)">
                                <InputNumber style={{ width: '100%' }} disabled precision={2} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item 
                                name="quantity" 
                                label="采购数量" 
                                rules={[{ required: true, message: '请输入采购数量' }]}
                            >
                                <InputNumber style={{ width: '100%' }} min={1} precision={0} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider />

                    <Form.Item shouldUpdate={(prev, curr) => prev.quantity !== curr.quantity || prev.price !== curr.price}>
                        {({ getFieldValue }) => {
                            const quantity = getFieldValue('quantity') || 0;
                            const price = getFieldValue('price') || 0;
                            const total = quantity * price;
                            const isOverBalance = total > (accountInfo.balance + accountInfo.creditLimit);

                            return (
                                <div style={{ 
                                    background: '#fafafa', 
                                    padding: '16px', 
                                    borderRadius: '8px',
                                    border: isOverBalance ? '1px solid #ffccc7' : '1px solid #f0f0f0'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Text strong style={{ fontSize: '16px' }}>预计总价</Text>
                                        <Text strong style={{ fontSize: '24px', color: isOverBalance ? '#ff4d4f' : '#f5222d' }}>
                                            ¥ {total.toFixed(2)}
                                        </Text>
                                    </div>
                                    {isOverBalance && (
                                        <div style={{ color: '#ff4d4f', fontSize: '12px', marginTop: 8, textAlign: 'right' }}>
                                            <InfoCircleOutlined /> 余额不足，请减少采购数量或充值
                                        </div>
                                    )}
                                </div>
                            );
                        }}
                    </Form.Item>

                    <div style={{ marginTop: 24, padding: '0 4px' }}>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            说明：购买成功后，系统将自动从您的账户余额中扣除相应金额。若余额不足，则会消耗信用配额。
                        </Text>
                    </div>
                </Form>
            </Drawer>
        </div>
    );
};

export default ProductDevelop;
